import { useSelector } from "react-redux";

import { getUserAccountType } from "seneca-common/features/user/state";

import DashboardNavbar from "features/dashboard/features/dashboard-navbar";
import TeacherNavbar from "features/teachers/features/teacher-navbar";
import ParentNavbar from "features/parents/features/parent-navbar";
import GuestNavbar from "features/anonymous-pages/common/guest-navbar";
import { linkToSignIn, linkToSignUp } from "features/sign-up/links";

export function UnsubscribePageNavbar() {
  const userType = useSelector(getUserAccountType);

  switch (userType) {
    case "schoolstudent":
      return <DashboardNavbar />;
    case "schoolteacher":
      return <TeacherNavbar />;
    case "schoolparent":
      return <ParentNavbar />;
    default:
      return (
        <GuestNavbar
          linkToSignIn={linkToSignIn()}
          linkToSignUp={linkToSignUp()}
        />
      );
  }
}
